import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input({ required: true }) destination: string | readonly unknown[];
  @Input() queryParams: Params | null = null;
}
